// GENERATED FILE - DO NOT MODIFY

export enum CompanyTypeDto {
    Heyday = "Heyday",
    Passport = "Passport",
}